<div class="page min-h-screen bg-white font-sans text-gray-900 selection:bg-orange-100 selection:text-brand flex flex-col relative overflow-hidden">
  
  <!-- Background Decor -->
  <div class="absolute top-0 right-0 w-[500px] h-[500px] bg-orange-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 pointer-events-none translate-x-1/3 -translate-y-1/3"></div>
  <div class="absolute bottom-0 left-0 w-[500px] h-[500px] bg-yellow-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 pointer-events-none -translate-x-1/3 translate-y-1/3"></div>
  <div class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-orange-50 rounded-full mix-blend-multiply filter blur-3xl opacity-40 pointer-events-none"></div>

  <!-- Header / Logo -->
  <div class="w-full max-w-5xl mx-auto px-6 py-8 relative z-10">
    <a routerLink="/wizard/v2/landing" class="flex items-center gap-2 hover:opacity-80 transition-opacity">
      <img src="images/logo.png" alt="JustTeach Logo" class="h-8 w-auto"/>
    </a>
  </div>

  <!-- Main Content -->
  <div class="flex-1 flex items-center justify-center px-4 pb-12 relative z-10">
    <div class="max-w-md w-full">
      
      <!-- Card -->
      <div class="bg-white/80 backdrop-blur-xl border border-white shadow-2xl shadow-gray-200/50 rounded-3xl p-10 sm:p-12 text-center">
        
        <!-- Animated Spinner -->
        <div class="relative w-20 h-20 mx-auto mb-8">
          <!-- Outer ring -->
          <div class="absolute inset-0 rounded-full border-4 border-gray-100"></div>
          <!-- Spinning gradient ring -->
          <div class="spinner-ring absolute inset-0 rounded-full border-4 border-transparent border-t-brand border-r-brand/50"></div>
          <!-- Inner icon container -->
          <div class="absolute inset-2 bg-gradient-to-br from-brand to-brand-dark rounded-full flex items-center justify-center shadow-lg shadow-brand/30">
            <lucide-icon [img]="icons.CheckCircle" class="w-8 h-8 text-white"></lucide-icon>
          </div>
        </div>

        <!-- Text -->
        <h1 class="text-2xl sm:text-3xl font-extrabold text-gray-900 mb-3">
          Completing Sign In
        </h1>
        <p class="text-gray-500 text-base leading-relaxed mb-2">
          Please wait while we authenticate your account.
        </p>
        <p class="text-gray-400 text-sm">
          You'll be redirected automatically...
        </p>

        <!-- Progress dots animation -->
        <div class="flex items-center justify-center gap-2 mt-8">
          <div class="progress-dot w-2 h-2 rounded-full bg-brand"></div>
          <div class="progress-dot w-2 h-2 rounded-full bg-brand animation-delay-200"></div>
          <div class="progress-dot w-2 h-2 rounded-full bg-brand animation-delay-400"></div>
        </div>
      </div>

      <!-- Bottom hint -->
      <p class="text-center text-gray-400 text-sm mt-6">
        Having trouble? <a routerLink="/" class="text-brand font-semibold hover:underline">Try again</a>
      </p>
    </div>
  </div>
</div>
